module.exports = __webpack_public_path__ + "img/money.0e2f12a0.svg";